// src/patient2/Patient2Home.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  Search,
  Calendar,
  FileText,
  Stethoscope,
  HeartPulse,
} from "lucide-react";
import Patient2BottomNav from "./Patient2BottomNav";
import "./patient2.css";

export default function Patient2Home() {
  // later you can wire this to Firestore
  const nextAppointment = null; // or fake data for now

  return (
    <div className="p2-root">
      <div className="p2-shell">
        {/* HEADER / GREETING */}
        <header className="p2-header">
          <div className="p2-header-text">
            <div className="p2-hello">Hi 👋</div>
            <h1 className="p2-title">How are you feeling today?</h1>
            <p className="p2-subtitle">
              Tell us what&apos;s going on, we&apos;ll help you find the right doctor.
            </p>
          </div>
          <div className="p2-avatar-pill">
            <span className="p2-avatar-dot" />
            <span className="p2-avatar-text">My profile</span>
          </div>
        </header>

        {/* BIG SEARCH CARD */}
        <section className="p2-search-card">
          <div className="p2-search-header">
            <Search size={18} />
            <span>Search by symptom, doctor or clinic</span>
          </div>
          <div className="p2-search-input-row">
            <input
              className="p2-search-input"
              placeholder="e.g. dhimbje mesi, diabet, dermatolog..."
            />
            <button className="p2-search-btn">
              <Search size={18} />
            </button>
          </div>
          <div className="p2-search-tags">
            <button className="p2-chip">Dhimbje</button>
            <button className="p2-chip">Analiza</button>
            <button className="p2-chip">Online visitë</button>
          </div>
        </section>

        {/* NEXT APPOINTMENT */}
        <section className="p2-card">
          <div className="p2-card-header">
            <div className="p2-card-title-row">
              <Calendar size={18} />
              <span>My next appointment</span>
            </div>
            <Link to="/appointments" className="p2-link-small">
              View all
            </Link>
          </div>

          {nextAppointment ? (
            <div className="p2-apt-row">
              <div className="p2-apt-main">
                <div className="p2-apt-doctor">
                  Dr. {nextAppointment.doctorName}
                </div>
                <div className="p2-apt-service">
                  {nextAppointment.service || "Consultation"}
                </div>
                <div className="p2-apt-meta">
                  <span>{nextAppointment.dateLabel}</span>
                  <span className="p2-dot-separator">•</span>
                  <span>{nextAppointment.timeLabel}</span>
                </div>
              </div>
              <button className="p2-apt-cta">Join / Details</button>
            </div>
          ) : (
            <div className="p2-apt-empty">
              <p>No appointments yet.</p>
              <span>Book your first visit in a few taps.</span>
              <Link to="/explore" className="p2-ghost-btn">
                <Stethoscope size={16} />
                <span>Find a doctor</span>
              </Link>
            </div>
          )}
        </section>

        {/* QUICK ACTIONS */}
        <section className="p2-card">
          <div className="p2-card-header">
            <div className="p2-card-title-row">
              <HeartPulse size={18} />
              <span>Quick actions</span>
            </div>
          </div>
          <div className="p2-quick-grid">
            <Link to="/my-health/records" className="p2-quick-item">
              <div className="p2-quick-icon blue">
                <FileText size={18} />
              </div>
              <div className="p2-quick-label">My medical records</div>
            </Link>

            <Link to="/appointments" className="p2-quick-item">
              <div className="p2-quick-icon green">
                <Calendar size={18} />
              </div>
              <div className="p2-quick-label">Appointments</div>
            </Link>

            <Link to="/explore" className="p2-quick-item">
              <div className="p2-quick-icon purple">
                <Stethoscope size={18} />
              </div>
              <div className="p2-quick-label">Find a doctor</div>
            </Link>

            <Link to="/my-health" className="p2-quick-item">
              <div className="p2-quick-icon pink">
                <HeartPulse size={18} />
              </div>
              <div className="p2-quick-label">My health hub</div>
            </Link>
          </div>
        </section>

        <div className="p2-bottom-spacer" />
      </div>

      <Patient2BottomNav />
    </div>
  );
}
